import { useTranslation } from "react-i18next";

import type { PlannedOrder } from "@/api/planningRun";
import { formatDate, formatNumber } from "@/utils/formatters";

export function ExistingOrderTerms({ order }: { order: PlannedOrder }) {
  const { t } = useTranslation();
  if (order.sourceExecution == null) return null;
  return (
    <div className="rounded-md border p-3 text-sm">
      <p className="font-medium">
        {t("planningReview.existingOrder", "Existing order")} ·{" "}
        {order.sourceExecutionCode}
      </p>
      <p>
        {formatNumber(Number(order.sourceExecutionQuantity), {
          maximumFractionDigits: 4,
        })}{" "}
        · {formatDate(order.sourceExecutionDate!)}
      </p>
    </div>
  );
}
